import { defineMessage } from 'services/localization';

export const messages = {
    titleSchedule: defineMessage('schedule_payment'),
    titleTwoFA: defineMessage('authorise_the_payment'),
    create: defineMessage('create'),
    save: defineMessage('save'),
    description: defineMessage('select_payment_date_and_time'),
    paymentDate: defineMessage('payment_date'),
    paymentTime: defineMessage('payment_time'),
    placeholder: defineMessage('select'),
    requiredField: defineMessage('field_is_required'),
    twoFAToConfirm: defineMessage('to_confirm_the_batch_pa_s_on_the_batch_formbrbr'),
    twoFAYouCanCancel: defineMessage('you_can_cancel_the_paym_tatus_on_the_batch_form'),
    linkText: defineMessage('if_you_have_problems_refer_to_this_link'),
    supportArticle: defineMessage('support_article'),
    twoFAEnterCode: defineMessage('enter_the_authenticator_code'),
};
